// The front page, signed out: what TUNE Analytics is, how to start, and how a TUNE MFD signs in.
import { usePageTitle } from '../../shell/title';
import { ButtonLink } from '../../ui';
import { BooksIcon, CarIcon, ChartLineIcon } from '../../ui/icons';
import s from './Welcome.module.css';

const FEATURES = [
  {
    icon: ChartLineIcon,
    title: 'Telemetry',
    text: 'Every datalog your TUNE MFD records, with laps, sectors, a dyno and replay in the Analyser.',
  },
  {
    icon: CarIcon,
    title: 'Your garage',
    text: 'Each car with its MFD: its settings, changed here or on the MFD, its service history and its drives.',
  },
  {
    icon: BooksIcon,
    title: 'Dashboards and configs',
    text: "TUNE's, your own and those shared with you reach your MFDs by themselves. Make configs here, too.",
  },
];

export function Welcome() {
  usePageTitle('Welcome');
  return (
    <div className={s.page}>
      <section className={s.hero} aria-labelledby="welcome">
        <img className={s.logo} src="/logo.avif" alt="" width={120} height={67} />
        <h1 id="welcome" className={s.title}>
          TUNE Analytics
        </h1>
        <p className={s.lead}>Your cars, their datalogs and dashboards, in step with your TUNE MFD.</p>
        <div className={s.actions}>
          <ButtonLink to="/sign-up" size="large">
            Make an account
          </ButtonLink>
          <ButtonLink to="/sign-in" size="large" variant="gray">
            Sign in
          </ButtonLink>
        </div>
        <ButtonLink to="/telemetry/sample" variant="plain">
          Try a sample session
        </ButtonLink>
      </section>

      <section className={s.features} aria-label="What it does">
        {FEATURES.map(({ icon: Icon, title, text }) => (
          <article key={title} className={s.feature}>
            <Icon size={28} weight="bold" aria-hidden="true" />
            <h2 className={s.featureTitle}>{title}</h2>
            <p className={s.featureText}>{text}</p>
          </article>
        ))}
      </section>

      <section className={s.how} aria-labelledby="how">
        <h2 id="how" className={s.howTitle}>
          Sign in your TUNE MFD
        </h2>
        <ol className={s.steps}>
          <li>On the MFD, open Settings, then TUNE account.</li>
          <li>Scan the code it shows with your phone's camera.</li>
          <li>Sign in to TUNE Analytics, and choose the car the MFD is in.</li>
        </ol>
      </section>
    </div>
  );
}
